import { fromJS } from 'immutable'
import {
  FAVORITE_REQUEST,
  FAVORITE_SUCCESS,
  FAVORITE_FAILURE,
  FAVORITE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case FAVORITE_REQUEST:
      return state
        .set('isFetching', true)
    case FAVORITE_SUCCESS:
      return state
        .set('updatedUser', fromJS(action.payload.updatedUser))
        .set('status', action.payload.ok)
        .set('isFetching', false)
    case FAVORITE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case FAVORITE_RESET:
      return state
        .delete('updatedUser')
        .delete('status')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-favorite-reducer.js